module.exports = __webpack_public_path__ + "media/images/team/Kim-9138d1453531783f210457e9f7683621.jpg";